module.exports = __webpack_public_path__ + "static/media/比赛4.bf541fc2.jpg";